<template>
    <div id="app">
        <!--<img src="./assets/logo.png">-->
        <popup ref="popup" :activeKey="activeKey ? activeKey : '3'" v-show="popupNameStatus"></popup>
        <keep-alive include="MyStatistics">
            <router-view/>
        </keep-alive>
    </div>
</template>

<script>
import popup from "./components/SuperRider/template/popup.vue"

export default {
    name: 'App',
    data() {
        return {
            params: {},//url参数
            activeKey: "3",
            // 禁止滑动窗口的name
            noPopupNames: ["siteEntryMap", "siteEntryEdit", 'MyStatistics', 'DailyStatistical', 'DayWuXiaoDan', 'MonthStatistics',
                'MonthWuXiaoDan', 'MyTicket', "AllOrder", 'CanAppeal', 'MyBooks', 'Bill', 'BillDetails', 'BalanceList', 'FlowDetails',
                'MyComments', "myList", "WechatMessagePushRiderBinding", "WechatMessagePushChoose", "WechatMessagePushUnbound",
                "WechatMessagePushBinding", "Message", "MarketLoginBuild","riderMap","OrderAllStatus","SelectCity","siteEntry","transferPictures"],
            popupNameStatus: false,
        }
    },
    components: {
        popup
    },
    watch: {
        $route(now, old) {
            setTimeout(_ => {
                window.showLeftMenu = this.showLeftMenu;
                // console.log("watch $route",now.name,this.noPopupNames)
                if (this.noPopupNames.indexOf(now.name) > -1) {
                    this.popupNameStatus = false
                    this.$nextTick(_=>{
                        this.$refs.popup.onAllowShow()
                    })
                } else {
                    this.popupNameStatus = true
                    this.$nextTick(_=>{
                        this.$refs.popup.touch()
                    })
                }
            }, 200)
        }
    },
    mounted() {
        let _this = this //很重要把父路由的vue实例赋给_this
        _this.$root.$on('next', function (idName, router) {  //监听next事件，这里$root很重要，不懂去官网介绍
            _this.change(idName, router, 1) //调用父路由中的方法
        })
    },
    created() {
        this.touch();
        console.log(window.location.search)
        window.location.search.slice(1).split("&").forEach(item => {
            const kv = item.split("=");
            this.params[kv[0]] = kv[1];
        })
    },
    methods: {
        /**
         * 原生与vue交互
         */
        showLeftMenu() {
            console.log("我也裂开了")
            this.$refs.popup.showLeftMenu()
        },
        /**
         * 绑定右滑事件
         */
        touch: function () {
            setTimeout(() => {
                let aaa = this.$refs.popup.getData(this.params);
            }, 200)
        },
    }
}
</script>

<style lang="less">
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50
}

body {
    background: #eeeeee !important;
}

.flex-row {
    display: flex;
    flex-direction: row;
}

.flex-column {
    display: flex;
    flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/App.vue